import React, { useCallback, useMemo } from "react";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";

import { Info } from "@mui/icons-material";
import { Tooltip, Typography } from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import FilterComponent from "../../../components/Filter/Filter.component";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import StatusPill from "../../../components/Status/StatusPill.component";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useReportedSideEffectsListHook from "./ReportedSideEffectsListHook";
import useRoles from "../../../hooks/RoleHook";
import {  PrimaryButton} from "../../../components/Buttons/PrimaryButton";
import CircularProgress from "@mui/material/CircularProgress";
const ReportedSideEffectsList = (props) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    isSidePanel,
    handleSideToggle,
    handlePageChange,
    handleEdit,
    handleEditSidePannel,
    handleFilterDataChange,
    handleSearchValueChange,
    handleProfile,
    configFilter,
    editData,
    handleDetail,
    handleExport,
    isSubmitting
  } = useReportedSideEffectsListHook({});
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.REPORTED_SIDE_EFFECTS);
  const editDataId = editData ? editData.id : null;

  const {
    present,
    all: allData,
    currentPage,
    is_fetching: isFetching,
  } = useSelector((state) => state.side_effects);

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>
            {`${capitalizeFirstLetter(
              user?.userObj?.full_name || "N/A"
            )}`}{" "}
          </div>
          <div>{`${user?.userObj?.full_contact}`} </div>
        </div>
      </div>
    );
  }, []);

  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"Active"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"Inactive"} color={"high"} />;
    }
  }, []);

  const tableStructure = useMemo(
    () => [
      {
        key: "reporter_name",
        label: "Reported By",
        sortable: true,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },

      {
        key: "medicine",
        label: "Medicine",
        sortable: false,
        render: (temp, all) => <div>{all?.medicine_name}</div>,
      },
      {
        key: "client",
        label: "Client",
        sortable: false,
        render: (temp, all) => (
          <div>{capitalizeFirstLetter(all?.client_name)}</div>
        ),
      },
      {
        key: "program",
        label: "Program",
        sortable: false,
        render: (temp, all) => (
          <div className={styles.program}>{capitalizeFirstLetter(all?.program_name)}</div>
        ),
      },
      {
        key: "reported_on",
        label: "Reported On",
        sortable: false,
        render: (temp, all) => <div>{all?.createdAtText}</div>,
      },
      {
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
            {canRead &&
            <Tooltip
            title={<>View Detail</>}
            aria-label="info"
            placement="right"
            className={styles.infoTip}
          >
            <IconButton
              onClick={(e) => {
                handleDetail(all);
              }}
              disableRipple="false"
              className={styles.icon}
            >
              <Info fontSize={"small"} />
            </IconButton>
            </Tooltip>
            }
          </div>
        ),
      },
    ],
    [
      renderFirstCell,
      renderStatus,
      handleEdit,
      handleProfile,

      handleEditSidePannel,
    ]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: present,
      count: allData.length,
      page: currentPage,
      draggable: true,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    present,
    currentPage,
  ]);

  return (
    <div>
      <ShadowBox className={styles.container}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            Reported Side Effects List
          </Typography>
          {/* <PrimaryButton
          onClick={handleExport}
          disabled={isSubmitting} 
        >
          {isSubmitting ? (  <CircularProgress size={24} color={"primary"} /> ) : ("EXPORT")}
        </PrimaryButton> */}
        </div>
        
        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={configFilter}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
            placeholder="Search by reporter or medicine name"
          />
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default ReportedSideEffectsList;
